import React from "react";
import { formatRupiah } from "../../utils/ecommerce";

const ReceiptPage = ({ orderResult, downloadOrderPdf, getWhatsappUrl, backToHome }) => {
  if (!orderResult) {
    return <div className="catalog-state">Data checkout belum tersedia.</div>;
  }

  return (
    <main className="page-container">
      <section className="receipt-panel">
        <div className="receipt-header">
          <div>
            <h1>Checkout Berhasil</h1>
            <p>Nomor Order: {orderResult.nomorOrder}</p>
          </div>
          <div className="receipt-status">{orderResult.status}</div>
        </div>
        <div className="receipt-body">
          <div>
            <h2>Data Pengiriman</h2>
            <p>
              <b>Nama:</b> {orderResult.nama}
            </p>
            <p>
              <b>No HP:</b> {orderResult.nomorHandphone}
            </p>
            <p>
              <b>Alamat:</b> {orderResult.alamatPengiriman}
            </p>
          </div>
          <div>
            <h2>Item Pesanan</h2>
            {(orderResult.items || []).map((item) => (
              <div className="receipt-line" key={item.id}>
                <span>
                  {item.namaBarang} x{item.qty}
                </span>
                <b>{formatRupiah(item.subtotal)}</b>
              </div>
            ))}
            <div className="receipt-total">
              <span>Total</span>
              <b>{formatRupiah(orderResult.totalHarga)}</b>
            </div>
          </div>
        </div>
        <div className="receipt-actions">
          <button type="button" onClick={() => window.print()}>
            Cetak
          </button>
          <button type="button" onClick={downloadOrderPdf}>
            Download PDF
          </button>
          <a href={getWhatsappUrl()} target="_blank" rel="noreferrer">
            Konfirmasi via WA Admin
          </a>
          <button type="button" onClick={backToHome}>
            Kembali Belanja
          </button>
        </div>
      </section>
    </main>
  );
};

export default ReceiptPage;
